import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50e80fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bindwx"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "绑定用户", -1))
const _hoisted_3 = { class: "bindwx-phone" }
const _hoisted_4 = {
  key: 1,
  class: "bindwx"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "登录中...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "bindwx"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "等待授权...", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { onMounted, reactive, ref } from 'vue';
import {
  useBaseUserStore,
  useRoute,
  useRouter,
} from 'juou-managebase-ui';
import { ElForm, ElMessage } from 'element-plus';
import { useApi } from '@/hooks/useApi';
import { useWx } from '@/hooks/useWx';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const wx = useWx();
const baseUserStore = useBaseUserStore();
const route = useRoute();
const router = useRouter();
const countDown = ref(0);


const getCurrentUrl = () => {
  const { protocol, hostname, pathname } = window.location;
  return encodeURI(`${protocol}//${hostname}${pathname}`);
};

const loginCode = ref('');
const wxappid = ref('');
const tips = ref('');
const form = ref({
  phone: '',
  phoneCode: '',
});
const formRef = ref<InstanceType<typeof ElForm>>();

const rules = reactive<any>({
  phone: [
    { required: true, message: '请输入手机号' },
    // eslint-disable-next-line prefer-named-capture-group
    { regex: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/u, message: '手机号格式错误' },
  ],
  phoneCode: [
    { required: true, message: '请输入验证码' },
    { regex: /^\d{6}$/u, message: '请输入6位数字验证码' },
  ],
});

const back = () => {
  if (tips.value) {
    alert(tips.value);
  }
  wx.closeWindow();
};


const countDownStart = () => {
  countDown.value = 60;
  const timer = setInterval(() => {
    countDown.value--;
    if (countDown.value === 0) {
      clearInterval(timer);
    }
  }, 1000);
};


const sendSms = async() => {
  await formRef.value?.validate();

  try {
    await useApi().wxApi.sendCodewx({
      phone: Number(form.value.phone),
    });
    countDownStart();
    ElMessage.success('发送成功');
  } catch (error) {
    ElMessage.error('发送失败，请勿频繁发送');
  }
};

const loginLoading = ref(false);

const handleLogin = async() => {
  try {
    loginLoading.value = true;
    const res = await useApi().wxApi.loginwx({
      loginCode: loginCode.value,
    }, {
      headers: {
        appid: wxappid.value,
      },
    });
    baseUserStore.setLoginInfo({
      accessToken: res.data.data.token,
      phone: res.data.data.phone,
      meta: res.data.data.meta,
    });
    ElMessage.success('登录成功');
    back();
  } catch (error) {
    console.log(error);
    // 登录失败则进入手机号注册
    window.location.href = `${getCurrentUrl()}?state=register_${tips.value}&appid=${wxappid.value}`;
  } finally {
    loginLoading.value = false;
  }
};

const bindLoading = ref(false);

const handleBind = async() => {
  await formRef.value?.validate();

  try {
    bindLoading.value = true;
    await useApi().wxApi.registerwx({
      phone: Number(form.value.phone),
      phoneCode: form.value.phoneCode,
      loginCode: loginCode.value,
    }, {
      headers: {
        appid: wxappid.value,
      },
    });
    ElMessage.success('绑定成功');
    window.location.href = `${getCurrentUrl()}?state=${tips.value}&appid=${wxappid.value}`;
  } catch (error) {
    ElMessage.error('绑定失败');
  } finally {
    bindLoading.value = false;
  }
};


onMounted(async() => {
  const { code, state = '', appid } = route.query;
  tips.value = state as string;
  wxappid.value = appid as string;
  loginCode.value = code as string;

  /*   if (baseUserStore.token) {
    back();
    return;
  } */


  const currentUrl = getCurrentUrl();
  if (!code) {
    const res = await useApi().wxApi.getWxOpenAppidwx();


    window.location.href
      = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${
        currentUrl
      }&response_type=code&state=${state}&scope=snsapi_userinfo&component_appid=${res.data.data}#wechat_redirect`;
    return;
  }

  if ((state as string).startsWith('register_')) {
    tips.value = (state as string).slice('register_'.length);
  } else {
    handleLogin();
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (loginCode.value && !loginLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(ElForm), {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "auto",
          rules: rules,
          style: {"max-width":"600px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_input, {
                    modelValue: form.value.phone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.phone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: sendSms,
                    disabled: countDown.value > 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(countDown.value > 0 ?
              `${countDown.value}秒后重新发送` : '发送验证码'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "验证码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.phoneCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.phoneCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  style: {"width":"100%"},
                  onClick: handleBind,
                  loading: bindLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("绑定")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]))
    : (loginLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
}
}

})